/// <reference path='../../../typings/hibachiTypescript.d.ts' />
/// <reference path='../../../typings/tsd.d.ts' />


class TrustAsHTML{
    //@ngInject
    public static Factory(){
        return function($sce){ return $sce.trustAsHtml; }
    }
    
}
export {
    TrustAsHTML
};